export class FormGroup {
  id: string | undefined;
  name: string | undefined;
  tag: string | undefined;
  description: string | undefined;
  owners: string[] | undefined;
  hide: boolean | undefined;
  options: Record<string, string> | undefined;
  links: Record<string, string> | undefined;

  constructor() {
    this.name = '';
    this.tag = '';
    this.description = '';
    this.owners = [];
    this.hide = false;
    this.options = {};
    this.links = {};
  }
}
